import React from "react";
import {
  BellIcon,
  UserCircle2Icon,
  CalendarIcon
} from "lucide-react";

import { 
  BarChart, 
  Bar, 
  XAxis, 
  Line,
  YAxis, 
  Tooltip, 
  ResponsiveContainer ,
  PieChart,
  Pie,
  CartesianGrid,
  Cell,
  LineChart
  // Tooltip,
  // ResponsiveContainer
} from "recharts";

// import {
//   PieChart,
//   Pie,
//   Cell,
//   Tooltip,
//   ResponsiveContainer
// } from "recharts";


import logonav from "/src/assets/images/logonav.png";
import logo from "/src/assets/images/logo.jpeg";

const Dashboard = () => {

  const chartData = [
  { name: "Pre Check", value: 55 },
  { name: "Survey In Progress", value: 25 },
  { name: "Reject Survey", value: 12 },
  { name: "Credit Review", value: 12 },
  { name: "Credit Approval", value: 12 },
];

const chartColors = ["#6B7280", "#3B82F6", "#EF4444", "#FACC15", "#22C55E"];

  const monthlyTarget = [
    { label: "Pre Check", value: 55, color: "bg-gray-500" },
    { label: "Survey In Progress", value: 25, color: "bg-blue-500" },
    { label: "Reject Survey", value: 12, color: "bg-red-500" },
    { label: "Credit Review", value: 12, color: "bg-yellow-500" },
    { label: "Credit Approval", value: 12, color: "bg-green-500" },
  ];

  const branchData = [
  { name: "Jakarta", total: 120 },
  { name: "Bandung", total: 85 },
  { name: "Bogor", total: 70 },
  { name: "Depok", total: 55 },
];


  const tasks = [
    {
      ref: "LD1023",
      name: "Dheeraj Sharma",
      type: "Education Loan",
      amount: "IDR 250,000,000",
      status: "Document Missing",
    },
    {
      ref: "LD1024",
      name: "Mohammed Ali",
      type: "Car Loan",
      amount: "IDR 450,000,000",
      status: "New Application",
    },
    {
      ref: "LD1025",
      name: "Sadia",
      type: "Home Loan",
      amount: "IDR 1,200,000,000",
      status: "Final Approval Needed",
    },
    {
      ref: "LD1026",
      name: "Ahsan",
      type: "SME Loan",
      amount: "IDR 800,000,000",
      status: "Address Verification",
    },
  ];

  const processRateData = [
  { stage: "Pre Check", value: 100 },
  { stage: "Survey", value: 70 },
  { stage: "Credit Review", value: 50 },
  { stage: "Approval", value: 30 },
];

const goliveStatusData = [
  { name: "Sudah Go Live", value: 60 },
  { name: "Dalam Proses", value: 25 },
  { name: "Belum Go Live", value: 15 },
];

const goliveColors = ["#10B981", "#FBBF24", "#EF4444"];

const unitSoldData = [
  { branch: "Jakarta", units: 120 },
  { branch: "Bandung", units: 95 },
  { branch: "Surabaya", units: 85 },
  { branch: "Bogor", units: 65 },
];

const namanya = localStorage.getItem("namanya");

  return (
    <div className="min-h-screen font-sans text-gray-800 bg-white">
      {/* <header className="h-16 bg-white shadow flex items-center justify-end px-6">
        <div className="flex items-center gap-6">
          <BellIcon className="h-6 w-6 text-gray-600" />
          <UserCircle2Icon className="h-8 w-8 text-gray-600" />
        </div>
      </header> */}

      <main className="p-8 space-y-8">
        <div className="flex items-center justify-between flex-wrap gap-4">
          {/* Logo at top-right */}
  <img
    src={logo}
    alt="logo"
    className="absolute top-0 right-20 w-40 h-40 object-contain"
  /> 
          <div>
            <h1 className="text-2xl font-semibold">Selamat Datang, {namanya}</h1>
            {/* <p className="text-sm text-gray-500">Your task this week is 60% completed</p> */}
            
          </div>
            
           <div>
            {/* <span className="text-xs text-[#4d0702] font-semibold tracking-widest block leading-tight">
              G-LAST
            </span> */}
            {/* <img src={logo} alt="logo" className="w-40 h-40 object-contain" /> */}
            {/* <span className="text-sm text-[#4d0702] font-bold tracking-wide leading-tight whitespace-nowrap">
              GRATAMA FINANCE
            </span> */}
          </div>
          {/* <div className="flex gap-3 flex-wrap">
            <button className="bg-[#4d0702] hover:bg-[#350400] text-white px-4 py-2 rounded-lg text-sm shadow">
              New Priority (10)
            </button>
            <button className="bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded-lg text-sm shadow">
              Review Priority (3)
            </button>
            <button className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg text-sm shadow">
              Add Research (5)
            </button>
          </div> */}
        </div>

        {/* Monthly Target + Calendar + Notification Section */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-6">
  {/* Application Info */}
  <div className="bg-white rounded-xl shadow p-6">
    <h3 className="font-semibold mb-2">APPLICATION INFO</h3>
    <p className="text-sm text-gray-500 mb-4">June 2025</p>
    <div className="space-y-3">
      {monthlyTarget.map((item) => (
        <div
          key={item.label}
          className="flex items-center justify-between border rounded px-3 py-2"
        >
          <div className="flex items-center gap-2">
            <span className={`h-3 w-3 rounded-full ${item.color}`}></span>
            <span className="text-sm font-medium text-gray-700">
              {item.label.toUpperCase()}
            </span>
          </div>
          <span
            className={`text-xs font-bold px-2 py-1 rounded text-white ${item.color}`}
          >
            {item.value}
          </span>
        </div>
      ))}
    </div>
  </div>

{/* Go Live Status Chart */}
<div className="bg-white rounded-xl shadow p-6">
  <h3 className="font-semibold mb-2">Status Go Live Kontrak</h3>
  <ResponsiveContainer width="100%" height={200}>
    <PieChart>
      <Pie
        data={goliveStatusData}
        dataKey="value"
        nameKey="name"
        cx="50%"
        cy="50%"
        outerRadius={60}
        label
      >
        {goliveStatusData.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={goliveColors[index % goliveColors.length]} />
        ))}
      </Pie>
      <Tooltip />
    </PieChart>
  </ResponsiveContainer>
</div>

{/* Unit Sales Chart */}
<div className="bg-white rounded-xl shadow p-6">
  <h3 className="font-semibold mb-2">Penjualan Unit Mobil (Bulan Ini)</h3>
  <ResponsiveContainer width="100%" height={200}>
    <BarChart data={unitSoldData}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="branch" />
      <YAxis />
      <Tooltip />
      <Bar dataKey="units" fill="#3B82F6" />
    </BarChart>
  </ResponsiveContainer>
</div>

</div>

        {/* Tasks List */}
        <div className="bg-white rounded-xl shadow p-6">
          <h3 className="font-semibold mb-4">Task List Pre Check</h3>
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead>
                <tr className="text-left text-gray-600 border-b">
                  <th className="py-2 px-3">Application ID</th>
                  <th className="px-3">Customer Name</th>
                  <th className="px-3">NIK</th>
                  <th className="px-3">Marital Status</th>
                  <th className="px-3">Spouse Name</th>
                  <th className="px-3">Branch</th>
                  <th className="px-3">CMO</th>
                  <th className="px-3">Dealer</th>
                  {/* <th className="px-3">Status</th> */}
                  {/* <th className="px-3 text-center">Action</th> */}
                </tr>
              </thead>
              <tbody>
                {tasks.map((t) => (
                  <tr key={t.ref} className="border-b last:border-none hover:bg-gray-50">
                    <td className="py-2 px-3 whitespace-nowrap">{t.ref}</td>
                    <td className="px-3 whitespace-nowrap">{t.name}</td>
                    <td className="px-3 whitespace-nowrap">{t.name}</td>
                    <td className="px-3 whitespace-nowrap">{t.type}</td>
                    <td className="px-3 whitespace-nowrap">{t.name}</td>
                    <td className="px-3 whitespace-nowrap">{t.type}</td>
                    <td className="px-3 whitespace-nowrap">{t.name}</td>
                    <td className="px-3 whitespace-nowrap">{t.name}</td>
                    {/* <td className="px-3 whitespace-nowrap">
                      <span
                        className={`px-2 py-1 rounded-full text-xs font-medium ${
                          t.status === "Document Missing"
                            ? "bg-yellow-100 text-yellow-800"
                            : t.status === "New Application"
                            ? "bg-blue-100 text-blue-800"
                            : t.status === "Final Approval Needed"
                            ? "bg-red-100 text-red-800"
                            : "bg-green-100 text-green-800"
                        }`}
                      >
                        {t.status}
                      </span>
                    </td> */}
                    {/* <td className="px-3 text-center">
                      <button className="text-blue-600 hover:underline">View</button>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;